import { render, staticRenderFns } from "./RichText-ask.vue?vue&type=template&id=4b380456"
import script from "./RichText-ask.vue?vue&type=script&lang=js"
export * from "./RichText-ask.vue?vue&type=script&lang=js"
import style0 from "./RichText-ask.vue?vue&type=style&index=0&id=4b380456&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports